import React from 'react';
import './AddDataButton.css';

function AddDataButton({ onClick }) {
  return (
    <button
      className="add-data-button add_data_pill"  // add_data_pill sets --color-background to #90a8ff
      onClick={onClick}
    >
      + Add Data
    </button>
  );
}

export default AddDataButton;
